
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-pin",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.025 0c-5.85 0-10.65 4.75-10.65 10.65 0 1.45.3 2.85.85 4.2 1.6 3.45 3.65 7.55 8.5 16.05.35.6.6 1.1 1.35 1.1s.95-.5 1.35-1.1c4.9-9.15 6.1-11.55 8.15-15.8.65-1.4.95-2.9 1.05-4.45 0-5.85-4.75-10.6-10.6-10.65zm0 15.45c-2.75 0-5-2.25-5-5s2.25-5 5-5 5 2.25 5 5c0 1.3-.55 2.6-1.45 3.5s-2.2 1.5-3.55 1.5z"}})])
          )
        }
      }
    